import { useEffect, useState } from "react";
import { RotateCcw } from "lucide-react";
import { toast } from "sonner";
import { fetchPastOrders } from "@/lib/bf";

export default function BFReorder({ c, cart, setQty }) {
  const [orders, setOrders] = useState([]);
  useEffect(() => {
    const lead = localStorage.getItem("bf_lead_id");
    if (lead) fetchPastOrders(lead).then(setOrders).catch(() => {});
  }, []);
  const preview = new URLSearchParams(window.location.search).has("preview");
  const mine = orders.filter((o) => preview || !o.preview).map((o) => ({ ...o, lines: o.lines.filter((l) => l.key.startsWith(`cp:${c.id}:`)) })).filter((o) => o.lines.length).slice(0, 3);
  if (!mine.length) return null;
  const redo = (o) => {
    o.lines.forEach((l) => setQty(l.key, (cart[l.key] || 0) + l.q));
    toast.success(`Am adăugat în coș ${o.lines.length === 1 ? "1 produs" : `${o.lines.length} produse`} din comanda ${o.no}`);
  };
  return (
    <div className="bf-reorder" data-testid="bf-reorder">
      <span className="bf-reorder-title"><RotateCcw size={14} /> Comandă rapidă · reia o comandă anterioară</span>
      <div className="bf-reorder-list">
        {mine.map((o) => (
          <button type="button" key={o.id} onClick={() => redo(o)} data-testid={`bf-reorder-${o.no}`}>
            <b>{o.no}</b>
            <small>{o.date} · {o.lines.length === 1 ? "1 produs" : `${o.lines.length} produse`} · {o.lines.reduce((s, l) => s + l.q, 0)} buc.</small>
            <em>Adaugă în coș</em>
          </button>
        ))}
      </div>
    </div>
  );
}
